import { render, staticRenderFns } from "./exam-alert.vue?vue&type=template&id=4b7a2afc"
import script from "./exam-alert.vue?vue&type=script&lang=ts"
export * from "./exam-alert.vue?vue&type=script&lang=ts"
import style0 from "./exam-alert.vue?vue&type=style&index=0&id=4b7a2afc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports